// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-77e8c0ec] {\n  fill: #fff\n}\n.st77[data-v-77e8c0ec] {\n  fill: #df6080\n}\n.st78[data-v-77e8c0ec] {\n  fill: #e788a0\n}\n", ""]);
// Exports
module.exports = exports;
